import React, { Component } from 'react'
import _ from 'lodash'
import { Row, Col, ControlLabel } from 'react-bootstrap'
import Repository from '../../felles/repository'

import { resolve } from '../../dependencies'

import NkaButton from 'nka-button'

import NkaInputNumber from 'nka-input-number'

import 'nka-input-number/dist/style.css'
import 'nka-button/dist/style.css'

export default class SmsContainer extends Component {
    constructor(props) {
        super(props)

        this.state = {
            innstillinger: {
                lunsjTidspunkt: '',
                tidPerMaaler: undefined,
                lunsjTidMinutter: undefined
            }
        }

        this.onEndretVerdi = this.onEndretVerdi.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
    }

    componentDidMount() {
        Promise.all([
            this.hentLunsjtid(),
            this.hentTidPerMaaler(),
            this.hentLunsjTidMinutter()
        ]).then(([lunsjTidspunkt, tidPerMaaler, lunsjTidMinutter]) => {
            var inst = { lunsjTidspunkt, tidPerMaaler, lunsjTidMinutter }
            this.setState(s => ({ innstillinger: inst }))
        })
    }

    hentLunsjTidMinutter() {
        return resolve(Repository).hentLunsjTidMinutter()
    }

    hentLunsjtid() {
        return resolve(Repository).hentLunsjtidspunktForKunde()
    }

    hentTidPerMaaler() {
        return resolve(Repository).hentTidPerMaaler()
    }

    onEndretVerdi(event) {
        let innstillingerTmp = Object.assign({}, this.state.innstillinger)
        innstillingerTmp[event.target.name] = event.target.value

        this.setState({
            innstillinger: innstillingerTmp
        })
    }

    handleSubmit(event) {
        event.preventDefault()

        let innstillingerTmp = Object.assign({}, this.state.innstillinger)

        let innstillinger = [
            {
                Navn: 'LunsjTidspunkt',
                Verdi: innstillingerTmp.lunsjTidspunkt
            },
            {
                Navn: 'ArbeidstidprMaaler',
                Verdi: innstillingerTmp.tidPerMaaler
            },
            {
                Navn: 'LunsjtidMinutter',
                Verdi: innstillingerTmp.lunsjTidMinutter
            }
        ]

        _.map(innstillinger, innstilling => this.lagreInnstilling(innstilling))
        this.props.history.goBack()
    }

    lagreInnstilling(innstilling) {
        resolve(Repository).lagreInnstillingForKunde(innstilling)
    }

    render() {
        return (
            <div className="listeContainer">
                <h2>Arbeidslisterinnstillinger</h2>

                <Row>
                    <Col xs={12} md={2}>
                        <ControlLabel>Lunsj</ControlLabel>
                        <br />
                      
                        <input
                            type="time"
                            placeholder="Lunsj"
                            
                            name="lunsjTidspunkt"
                            className="nka-input-number nka-input-numberwhite"
                            value={this.state.innstillinger.lunsjTidspunkt}
                            onChange={this.onEndretVerdi}
                        />
                      
                    </Col>
                    </Row>
                    <Row>
                    <Col xs={12} md={2}>
                        <ControlLabel>Tid per måler</ControlLabel>
                        <br />
                        <NkaInputNumber
                            name="tidPerMaaler"
                            value={this.state.innstillinger.tidPerMaaler}
                            onChange={this.onEndretVerdi}
                        />
                    </Col>
                    </Row>
                    <Row>
                    <Col xs={12} md={2}>
                        <ControlLabel>Lunsjtid(min)</ControlLabel>
                        <br />
                        <NkaInputNumber
                            name="lunsjTidMinutter"
                            value={this.state.innstillinger.lunsjTidMinutter}
                            onChange={this.onEndretVerdi}
                        />
                    </Col>
                    </Row>

                <NkaButton onClick={this.handleSubmit} buttontype="primary">Lagre</NkaButton>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/innstillinger/arbeidslister/arbeidslisteContainer.jsx